export enum GetUserSessionIdReturnCodeEnum {
    Error = 1,

    ADE = 2,

    AlreadyExists = 3,

    ChooseChannelBusiness = 4,

    ChooseChannelDigitel = 5,

    OneChannelBusiness = 6,

    OneChannelDigitel = 7,

    ChooseOtherChannel = 8,

    NotIdentified = 9,

    OneChannelOther = 10,

    Identified = 11
}

export enum SendConfirmationCodeReturnCodeEnum {

    Success = 0,

    Error = 1,

    ExceededLimit = 2
}

export enum ConfirmationChannelEnum {

    Phone = 1,

    Email = 2
}

export enum VerificationTypeEnum {

    Id = 1,

    Phone = 2,

    Email = 3
}

export enum VerifyConfirmationCodeReturnCodeEnum {

    Valid = 0,

    TechnicalProblem = 1,

    NotValid = 2,

    ExceededLimit = 3
}

export enum ErrorCodeEnum {

    Technical = 1,

    ADE = 2,

    AlreadyExists = 3,

    SendConfirmationCodeError = 4,

    ExceededLimit = 5,

    NeedPhoneEmailConfirmation = 6,

    WrongData = 7
}

export enum CallTimeEnum {
    Morning = 1,

    Noon = 2
}

export enum RegStatus {

    Registred = 1,

    NotRegistredUploadedFile = 2,

    NotRegistredNotUploadedFile = 3,

    NotRegistredOther = 4
}